<button
  data-testid="button"
  [id]="id() || 'button'"
  [class]="[GetButtonClass(), GetButtonSize(), 'btn', 'w-full', 'flex', 'cursor-pointer']"
  [type]="type()"
  [disabled]="disabled() || loading()"
  (click)="onClick()">
  @if (loading()) {
  <span class="loading loading-spinner"></span>
  } @else { @if (icon()?.variant === 'left' && icon()?.path) {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 48 48"
    stroke-width="2.5"
    stroke="currentColor"
    class="size-[1.2em] mr-2">
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      [attr.d]="icon()!.path!" />
  </svg>
  } @if (icon()?.variant !== 'alone') {
    @if(color() === 'error' || color() === 'primary' || color() === 'success' ){
      <span
     class="text-white">{{ label() }}</span
  >}@else{
  <span>{{ label() }}</span>}
  } @if (icon()?.variant === 'right' && icon()?.path) {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 48 48"
    stroke-width="2.5"
    stroke="currentColor"
    class="size-[1.2em] ml-2">
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      [attr.d]="icon()!.path!" />
  </svg>
  } @if (icon()?.variant === 'alone' && icon()?.path) {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 48 48"
    stroke-width="2.5"
    stroke="currentColor"
    class="size-[1.2em]">
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      [attr.d]="icon()!.path!" />
  </svg>
  } }
</button>
